import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
window.__build = '20260911c'; // marca de build para forzar hash nuevo (evita caché de borde envenenada)
root.render(<App />);
